:host{display:flex;flex-direction:column;height:100%}app-add-edit-facility{flex:1}
/*# sourceMappingURL=add-edit-facility-dialog.component-Q6AA3SLF.css.map */
